<template>
  <account-short :account="account" :wallet="wallet" @disconnect="onClose" />
</template>

<script lang="ts" setup>
import { inject } from 'vue';
import { useWalletPlugin } from '@/composables/useWalletPlugin';

import { AccountShort } from '@/components/UI/AccountShort';

const dialogRef = inject('dialogRef');

const { account, wallet } = useWalletPlugin();
type IProps = {
  visible?: boolean;
};

defineProps<IProps>();
defineEmits(['update:visible']);

function onClose() {
  dialogRef.value.close();
}
</script>

<style lang="scss" scoped>
.send-button {
  width: 100%;
  margin-top: 10px;
}

.step {
  ::v-deep(.p-blockui) {
    opacity: 0;
  }
}
.account-text {
  margin-block: 0rem;
  font-weight: 600;
  font-size: 18px;
  color: var(--text-color);
}
.back-btn-placeholder {
  width: 22px;
}
</style>
